/* Prozone B2B — pz-signup.js
   Envoie la demande d'accès B2B à l'intake du Prozone Manager.
   Contrat : src/lib/b2bSignup/contract.ts (dépôt Manager). */
(function () {
  'use strict';

  var form = document.getElementById('pz-b2b-form');
  if (!form) return;

  var CFG      = window.pzB2B || {};
  var ENDPOINT = (CFG.routes && CFG.routes.signupApi) || '';
  var thanks   = document.getElementById('pz-b2b-thanks');
  var wrap     = document.getElementById('pz-b2b-form-wrap');
  var banner   = document.getElementById('pz-b2b-error');
  var submit   = document.getElementById('pz-b2b-submit');

  /* Les champs que le contrat accepte. Rien d'autre n'est envoyé : le payload
     est construit clé par clé plutôt que sérialisé depuis le DOM. */
  var TEXT_FIELDS = [
    'firstName', 'lastName', 'email', 'phone', 'company', 'vatNumber',
    'activityType', 'website', 'estimatedVolume', 'address', 'postalCode',
    'city', 'country', 'message', 'fax'
  ];
  /* Envoyés même vides serait un refus 400 : le contrat traite l'absence
     comme « non renseigné ». */
  var OPTIONAL = { website: true, message: true, fax: true };

  var TIMEOUT_MS = 15000;

  function val(name) {
    var el = form.elements[name];
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function clearErrors() {
    banner.hidden = true;
    banner.textContent = '';
    Array.prototype.forEach.call(form.querySelectorAll('.pz-input--bad'), function (el) {
      el.classList.remove('pz-input--bad');
    });
    Array.prototype.forEach.call(form.querySelectorAll('.pz-field-error'), function (el) {
      el.remove();
    });
  }

  function showBanner(html) {
    banner.innerHTML = html;
    banner.hidden = false;
    banner.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function showFieldErrors(errors) {
    var first = null;
    Object.keys(errors).forEach(function (key) {
      var el = form.elements[key];
      if (!el || !el.classList) return;
      el.classList.add('pz-input--bad');
      var msg = document.createElement('span');
      msg.className = 'pz-field-error';
      msg.textContent = errors[key];
      if (el.parentNode) el.parentNode.appendChild(msg);
      if (!first) first = el;
    });
    if (first) first.focus();
    if (errors._) showBanner(escapeHtml(errors._));
    else showBanner('Merci de corriger les champs signalés ci-dessous.');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mailtoFallback() {
    var subject = encodeURIComponent('Demande d’accès B2B — ' + (val('company') || val('email')));
    var body = encodeURIComponent(
      TEXT_FIELDS.filter(function (k) { return k !== 'fax' && val(k); })
        .map(function (k) { return k + ': ' + val(k); })
        .join('\n')
    );
    return 'mailto:info@prozone-distribution.ch?subject=' + subject + '&body=' + body;
  }

  function offline(reason) {
    showBanner(
      'Notre système d’inscription est momentanément indisponible' +
      (reason ? ' (' + escapeHtml(reason) + ')' : '') + '. ' +
      'Vous pouvez nous envoyer votre demande par e-mail : ' +
      '<a href="' + mailtoFallback() + '" style="color:#2E7D32;font-weight:600">' +
      'nous écrire avec les informations saisies</a>.'
    );
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();

    /* Le formulaire est en novalidate pour maîtriser l'affichage, mais on
       s'appuie quand même sur la validation native pour le premier passage. */
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (!ENDPOINT) { offline('endpoint non configuré'); return; }

    var payload = { consent: form.elements.consent.checked === true };
    TEXT_FIELDS.forEach(function (name) {
      var v = val(name);
      if (v === '' && OPTIONAL[name]) return;
      payload[name] = v;
    });

    var label = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Envoi en cours…';

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, TIMEOUT_MS);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (body) {
          return { status: res.status, body: body };
        });
      })
      .then(function (r) {
        if (r.status === 200 && r.body && r.body.ok) {
          if (wrap) wrap.hidden = true;
          form.hidden = true;
          if (thanks) {
            thanks.hidden = false;
            thanks.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          return;
        }
        if (r.status === 400 && r.body && r.body.errors) { showFieldErrors(r.body.errors); return; }
        if (r.status === 429) {
          showBanner('Trop de demandes envoyées depuis cette connexion. Merci de réessayer dans une heure, ou de nous écrire à info@prozone-distribution.ch.');
          return;
        }
        if (r.status === 503) {
          showBanner(escapeHtml((r.body && r.body.message) ||
            'Les inscriptions B2B sont momentanément fermées.'));
          return;
        }
        offline('erreur ' + r.status);
      })
      .catch(function (err) {
        offline(err && err.name === 'AbortError' ? 'délai dépassé' : 'connexion impossible');
      })
      .then(function () {
        clearTimeout(timer);
        submit.disabled = false;
        submit.textContent = label;
      });
  });
})();
